import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL_PLACEHOLDER = 'https://your-project-ref.supabase.co'
const SUPABASE_ANON_KEY_PLACEHOLDER = 'your-public-anon-key'

const rawSupabaseUrl = ((import.meta as any).env.VITE_SUPABASE_URL as string | undefined)
const rawSupabaseAnonKey = ((import.meta as any).env.VITE_SUPABASE_ANON_KEY as string | undefined)

const missingEnv: string[] = []

if (!rawSupabaseUrl || rawSupabaseUrl === SUPABASE_URL_PLACEHOLDER) {
  missingEnv.push('VITE_SUPABASE_URL')
}

if (!rawSupabaseAnonKey || rawSupabaseAnonKey === SUPABASE_ANON_KEY_PLACEHOLDER) {
  missingEnv.push('VITE_SUPABASE_ANON_KEY')
}

if (missingEnv.length > 0) {
  const guidance = missingEnv
    .map((key) => `  - ${key} (set this in apps/frontend/.env)`)
    .join('\n')

  throw new Error(
    `Supabase environment variables are missing or still using placeholder values:
${guidance}
Refer to apps/frontend/.env.example for details.`
  )
}

const supabaseUrl = rawSupabaseUrl as string
const supabaseAnonKey = rawSupabaseAnonKey as string

// Export the URL for use in API calls
export const SUPABASE_URL = supabaseUrl

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: {
      getItem: (key: string) => {
        return localStorage.getItem(key)
      },
      setItem: (key: string, value: string) => {
        localStorage.setItem(key, value)
      },
      removeItem: (key: string) => {
        localStorage.removeItem(key)
      }
    },
    storageKey: 'sb-auth-token',
    flowType: 'pkce'
  },
  global: {
    headers: {
      'X-Client-Info': 'sergio-app'
    }
  }
})

// Helper to get the current user session
export const getCurrentSession = async () => {
  const { data: { session }, error } = await supabase.auth.getSession()
  if (error) throw error
  return session
}

// Helper to get the current user
export const getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser()
  if (error) throw error
  return user
}
